export function trackPageView (page) {
  return {
    type: 'PAGE_VIEW',
    payload: page
  };
}